import React from 'react';
import HeaderMainPublic from '../../components/Header/HeaderMainPublic'
import {Linkgroup} from '../../components/Header/Linkgroup'
import EmailPwCard from './EmailPwCard';
import BaseFooter from '../../components/Footer/BaseFooter'
import { SP23_URL } from '../../constants';


export default function EmailPwPage() {

    return (

         <>
    
           <HeaderMainPublic linkgroup={ <> <Linkgroup destination={ SP23_URL } button_name='Home' />  </>}/>
           <EmailPwCard />
           <BaseFooter />
      
  </>
  )
}